export default __webpack_public_path__ + "static/media/1.ce408726.png";